export const walletWithdrawalService = {
  getPendingRequest: (data) =>
    window.axios.post("get-pending-withdrawal-request", data),
  requestStatusChange: (data) =>
    window.axios.post("withdrawal-status-change", data),
  getApprovedRequest: (data) =>
    window.axios.post("get-approved-withdrawal-request", data),
  getDeclinedRequest: (data) =>
    window.axios.post("get-cancelled-withdrawal-request", data),
};
